// extracted by mini-css-extract-plugin
export default {"layout":"a2gbBz7zHXLqEwioXVJA","content":"LWp6xxvYP6myb73bWEcB"};